import React, { Fragment } from 'react'
import { NumericFormat } from 'react-number-format'
import DateView from 'components/formatter/DateView'
import { getDateViewFromMysql, getStrDateLong, getStrDateTimeShort, money, postgresDateToIndonesia } from 'utils/MyUtils'

export const normalizeExportText = (value) => {
  if (value === null || value === undefined) {
    return ""
  }
  if (typeof value === "object" && value.__exportType) {
    return value
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value)
  }
  if (typeof value === "string") {
    return value
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .replace(/[ \t\f\v]+/g, " ")
      .replace(/ *\n */g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim()
  }
  if (Array.isArray(value)) {
    return value.map(normalizeExportText).filter(Boolean).join(" ")
  }
  if (React.isValidElement(value)) {
    return normalizeExportText(value.props?.children)
  }
  return String(value)
    .replace(/<style[\s\S]*?<\/style>/gi, "")
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<[^>]+>/g, "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/[ \t\f\v]+/g, " ")
    .replace(/ *\n */g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
}

export const getDataCellExportValue = (val, colname, item, coltype, exportMode = "") => {
  const dtype = coltype?.dtype ? coltype?.dtype : coltype?.type
  const renderExportFunc = coltype?.renderExportFunc

  if (renderExportFunc) {
    const rendered = renderExportFunc(val, colname, item, coltype, exportMode)
    if (rendered && typeof rendered === "object" && rendered.__exportType) {
      return rendered
    }
    return normalizeExportText(rendered)
  }

  switch (dtype) {
    case "date":
      return val ? postgresDateToIndonesia(val) || getStrDateLong(val) : ""
    case "datetime":
      return val ? getStrDateTimeShort(val) : ""
    case "money":
      return val !== null && val !== undefined ? money(val) : ""
    case "dropdown": {
      const { options, valueId, labelId } = coltype || {}
      if (options) {
        const res = options.filter((item) => String(item?.[valueId]) === String(val))
        return normalizeExportText(res[0]?.[labelId])
      }
      return normalizeExportText(val)
    }
    case "checkbox":
    case "checkboxform": {
      const { caption = "Aktif", captionFalse = "Nonaktif" } = coltype || {}
      return val ? caption : captionFalse
    }
    default:
      return normalizeExportText(val)
  }
}

const DataCell = (props) => {
  let { val, coltype, colname, item, exportMode = '', ...rest } = props
  const dtype = coltype?.dtype ? coltype?.dtype : coltype?.type
  const renderFunc = coltype?.renderFunc

  if (exportMode) {
    return <Fragment>{getDataCellExportValue(val, colname, item, coltype, exportMode)}</Fragment>
  }

  if (renderFunc) {
    return renderFunc(val, colname, item, coltype)
  } else {
    const element = coltype?.[colname]
    let { options, caption = "Aktif", captionFalse = "Nonaktif", valueId, labelId, ...rest } = coltype

    var valview = ""
    switch (dtype) {
      case "date":
        valview = <DateView val={val} />
        break
      case "datetime":
        valview = getStrDateTimeShort(val)
        break
      case "money":
        valview = money(val)
        break
      case "dropdown":
        if (options) {
          const res = options.filter((item) => {
            return item?.[valueId] === val;
          })
          valview = res[0]?.[labelId]
        } else {
          valview = val
        }
        break;
      case "checkbox":
        valview = val ? caption : captionFalse
        val = 1
        break;
      case "checkboxform":
        valview = val ? caption : captionFalse
        val = 1
        break;
      default:
        valview = val
    }

    if (colname === "no" || colname === "action") {
      valview = colname
    }
    return (
      <Fragment>{val && valview}</Fragment>
    )
  }
}

DataCell.defaultProps = {
  val: null,
  ctype: null,
  colname: null,
  item: null
}

export default DataCell
